import { API_RESERVATION_ROUTE } from 'constants/api.constant';
import AxiosUtil from 'utils/axios.util';

const ReservationRepository = {
  getReservationList(data) {
    try {
      return AxiosUtil.get(
        { url: `${API_RESERVATION_ROUTE}/list`, submitData: data },
        (res) => {
          return res;
        },
        (err) => {
          console.error(err.message);
        },
      );
    } catch (err) {
      console.error(err.message);
    }
  },

  getReservation(reservationId) {
    try {
      return AxiosUtil.get(
        { url: `${API_RESERVATION_ROUTE}/${reservationId}`, submitData: {} },
        (res) => {
          return res;
        },
        (err) => {
          console.error(err.message);
        },
      );
    } catch (err) {
      console.error(err.message);
    }
  },

  saveReservation(data) {
    try {
      return AxiosUtil.post(
        { url: `${API_RESERVATION_ROUTE}`, submitData: data },
        (res) => {
          return res;
        },
        (err) => {
          console.error(err.message);
        },
      );
    } catch (err) {
      console.error(err.message);
    }
  },

  changeReservationStatus(data) {
    try {
      return AxiosUtil.put(
        { url: `${API_RESERVATION_ROUTE}`, submitData: data },
        (res) => {
          return res;
        },
        (err) => {
          console.error(err.message);
        },
      );
    } catch (err) {
      console.error(err.message);
    }
  },
};

export default ReservationRepository;
